import _slicedToArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import dayjs from "dayjs";
import VideoPreview from "./components/VideoPreview.vue";
import ImagePreview from "./components/ImagePreview.vue";
import { mapActions } from "vuex";
import { debounce } from "lodash";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  name: "consult-list",
  mixins: [userPopMixin],
  components: {
    VideoPreview: VideoPreview,
    ImagePreview: ImagePreview
  },
  data: function data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10
      },
      // 搜索表单
      statusTags: {
        0: {
          label: "新咨询",
          color: "#2DB6B6"
        },
        1: {
          label: "待回复",
          color: "#F3B251"
        },
        2: {
          label: "已回复",
          color: "#111111"
        },
        3: {
          label: "已关闭",
          color: "#B7B7B7"
        }
      },
      statusList: [{
        value: 0,
        label: "新咨询"
      }, {
        value: 1,
        label: "待回复"
      }, {
        value: 2,
        label: "已回复"
      }, {
        value: 3,
        label: "已关闭"
      }],
      categoryList: [],
      followList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数
      contractInfo: {},
      contractDialogVisible: false,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      previewVideoUrl: "",
      imgArr: "",
      imgIndex: 0,
      pageDB: null
    };
  },
  watch: {
    searchForm: {
      handler: function handler(nVal) {
        if (this.pageDB) {
          this.pageDB.set("searchFormConsult", this.searchForm).write();
        }
        if (nVal.status === 0) {
          this.searchForm.followId = "";
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.databasePage({
              user: true
            });
          case 1:
            _this.pageDB = _context.v;
            _context.n = 2;
            return _this.pageDB.value();
          case 2:
            data = _context.v;
            if (data !== null && data !== void 0 && data.searchFormConsult) {
              _this.searchForm = _objectSpread(_objectSpread({}, data.searchFormConsult), {}, {
                pageNum: 1,
                pageSize: 10
              });
            }
            _this.getData();
            _this.getCategory();
            _this.getFollowList();
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/db", ["databasePage", "databasePageClear"])), {}, {
    setStar: debounce(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.$api.addStar({
                advisoryId: row.id,
                type: row.star ? 0 : 1
              });
            case 1:
              res = _context2.v;
              if (res.data) {
                this.getData();
                this.$message.success(row.star ? "已取消星标" : "已设为星标");
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), 200),
    previewVideo: function previewVideo(url) {
      this.videoVisible = true;
      this.previewVideoUrl = url;
      this.$refs.videoPreview.show();
    },
    handleDateChange: function handleDateChange(value) {
      if (value && value.length === 2) {
        var _value = _slicedToArray(value, 2),
          start = _value[0],
          end = _value[1];
        var endDate = dayjs(end).hour(23).minute(59).second(59).format("YYYY-MM-DD HH:mm:ss");
        this.searchForm.time = [start, endDate];
        this.getData("search");
      }
    },
    selectCount: function selectCount(phone) {
      this.searchForm.phone = phone;
      this.getData("search");
    },
    toDetail: function toDetail(row) {
      var userId = row.userId,
        id = row.id;
      var _this$searchForm = this.searchForm,
        pageNum = _this$searchForm.pageNum,
        pageSize = _this$searchForm.pageSize;
      localStorage.setItem("consult-page", JSON.stringify({
        pageNum: pageNum,
        pageSize: pageSize
      }));
      this.$router.push({
        path: "/consult/detail",
        query: {
          id: id,
          userId: userId,
          pageNum: pageNum,
          pageSize: pageSize
        }
      });
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pageNum = pn;
      this.getData();
    },
    getFollowList: function getFollowList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this2.$api.getAdminUser({
                type: "customer_service"
              });
            case 1:
              res = _context3.v;
              _this2.followList = res.data || [];
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getCategory: function getCategory() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this3.$api.getCategoryList();
            case 1:
              res = _context4.v;
              _this3.categoryList = res.data || [];
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getData: function getData(type) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this4$searchForm$tim, _this4$searchForm$tim2, _res$data, _res$data2;
        var phone, pageLocal, _ref2, pageNum, pageSize, params, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (type === "search") {
                _this4.searchForm.pageNum = 1;
              }
              phone = localStorage.getItem("consult-phone");
              pageLocal = localStorage.getItem("consult-page");
              _ref2 = pageLocal ? JSON.parse(pageLocal) : {}, pageNum = _ref2.pageNum, pageSize = _ref2.pageSize;
              if (phone) {
                _this4.searchForm.phone = phone;
                localStorage.removeItem("consult-phone");
              }
              if (pageNum && pageSize) {
                _this4.searchForm.pageNum = pageNum;
                _this4.searchForm.pageSize = pageSize;
                localStorage.removeItem("consult-page");
              }
              _this4.tableLoading = true;
              params = _objectSpread({
                startTime: ((_this4$searchForm$tim = _this4.searchForm.time) === null || _this4$searchForm$tim === void 0 ? void 0 : _this4$searchForm$tim[0]) || "",
                endTime: ((_this4$searchForm$tim2 = _this4.searchForm.time) === null || _this4$searchForm$tim2 === void 0 ? void 0 : _this4$searchForm$tim2[1]) || ""
              }, _this4.searchForm);
              delete params.time;
              _context5.n = 1;
              return _this4.$api.getAdvisoryList(params);
            case 1:
              res = _context5.v;
              _this4.tableData = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.content) || [];
              _this4.total = ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.totalSize) || 0;
              _this4.tableLoading = false;
              _this4.getUserListByIds(_this4.tableData, "userId");
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    reset: function reset() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10
      };
      this.getData("search");
    }
  })
};